import { IconDarkLightOutline18 as DarkLight } from "nucleo-ui-outline-18"

import { SettingItem } from "../settings-switches/setting-item"
import {
	SettingsCardInsetContext,
	SettingsContainer,
} from "../settings-switches/settings-container"

export const THEME_SETTINGS_HREF = "/settings/portal/theme"

export function ThemeSection() {
	return (
		<SettingsCardInsetContext.Provider value={false}>
			<SettingsContainer>
				<SettingItem
					Icon={DarkLight}
					title="Theme settings"
					description="Adjust the cover image and colors of your portal and widget."
					link={THEME_SETTINGS_HREF}
				/>
			</SettingsContainer>
		</SettingsCardInsetContext.Provider>
	)
}
